const hasValue = (item: any): boolean => {
    if (item) {
        if (item.objectId > 0) {
            return true;
        }
    }
    return false;
};

export default hasValue;